import React from 'react';
import { Skeleton } from '@mui/material';

export const DashboardWidgetSkeleton = ({ height = 'clamp(240px, 34vh, 460px)' }) => {
    return <Skeleton variant="rectangular" style={{ width: '100%', height, borderRadius: '12px' }} />;
};
